import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useStore } from '../stores/store';
import { AppRoute } from '../constants/route';
import {
  generateLocaleRoute,
  generateStartParcelCreationRoute,
} from '../utils/uri/uri.utils';

export const useStartParcelCreation = () => {
  const {
    navStore: {
      isLeftSidebarOpened,
      closeAllRightSidebars,
      toggleLeftSidebar,
      setSelectedService,
      setSelectedMenuSections,
      setServicesSidebarVisibility,
    },
    parcelCreationStore: {
      resetAllData,
      prefillDraftParcelData,
      setIsDraftEditing,
      shippingType,
      updateShipmentAndNavigation,
      setPrefillInProgress,
      setIsParcelCreationInProgress,
    },
    parcelListStore: { resetSearchOptions },
  } = useStore();
  const navigate = useNavigate();

  const handleStartParcelCreation = useCallback(
    async (
      url: string = generateStartParcelCreationRoute(),
      shipmentId: number | undefined = undefined
    ) => {
      setServicesSidebarVisibility(false);
      if (isLeftSidebarOpened) {
        toggleLeftSidebar();
      }
      closeAllRightSidebars();
      setSelectedService(undefined);
      setSelectedMenuSections([]);

      window.scrollTo({ top: 0, behavior: 'smooth' });
      resetAllData();
      resetSearchOptions();

      // Required for draft-editing scenario
      if (shipmentId) {
        setIsDraftEditing(true);
        setPrefillInProgress(true);
        updateShipmentAndNavigation(shipmentId, true).then((newNavigation) => {
          prefillDraftParcelData(newNavigation?.current?.name);
        });
      }

      // TODO: domestic is not supported currently.
      if (shippingType !== 'international') {
        navigate(generateLocaleRoute(AppRoute.COMING_SOON), {
          state: { key: new Date().getTime() },
        });
        return;
      }

      setIsParcelCreationInProgress(true);

      navigate(url, {
        state: { key: new Date().getTime() },
      });
    },
    [
      setServicesSidebarVisibility,
      setPrefillInProgress,
      prefillDraftParcelData,
      isLeftSidebarOpened,
      closeAllRightSidebars,
      setSelectedService,
      setSelectedMenuSections,
      shippingType,
      toggleLeftSidebar,
      navigate,
      setIsDraftEditing,
      updateShipmentAndNavigation,
      setIsParcelCreationInProgress,
      resetAllData,
      resetSearchOptions,
    ]
  );

  return handleStartParcelCreation;
};
